import { FC } from "react"
import {
  VictoryAxis,
  VictoryChart,
  VictoryContainer,
  VictoryLine,
  VictoryScatter,
  VictoryTooltip,
  VictoryLabel,
} from "victory"
import { colors } from "../../utils/theme"
import { ChartDataPoints } from "../../utils/types"
import ChartTooltip from "../atoms/ChartTooltip"
import {
  TREND_CHART,
  chartAxisLabelStyle,
  chartTickLabelStyle,
} from "./charts/chartTypography"

const TimeAtHomeChart: FC<{
  data: ChartDataPoints[][]
  categories: string[]
}> = ({ data, categories }) => (
  <div
    style={{
      marginTop: 16,
      width: "100%",
      maxWidth: "100%",
      minWidth: 0,
      overflow: "hidden",
    }}
  >
    <VictoryChart
      height={TREND_CHART.height}
      width={TREND_CHART.width}
      domainPadding={{ x: [0, 48] }}
      padding={TREND_CHART.padding}
      containerComponent={
        <VictoryContainer
          responsive
          style={{ width: "100%", height: "auto" }}
        />
      }
    >
      <VictoryAxis
        orientation="top"
        tickComponent={<></>}
        tickLabelComponent={<></>}
        style={{
          axis: { stroke: colors.neutral.clay },
        }}
      />
      <VictoryAxis
        orientation="right"
        dependentAxis={true}
        tickComponent={<></>}
        tickLabelComponent={<></>}
        style={{
          axis: { stroke: colors.neutral.clay },
        }}
      />
      <VictoryAxis
        orientation="bottom"
        offsetY={44}
        tickFormat={(tick, index) => (index % 2 !== 0 ? tick : "")}
        style={{
          tickLabels: chartTickLabelStyle,
          axis: { stroke: colors.neutral.clay },
        }}
      />
      <VictoryAxis
        orientation="left"
        dependentAxis={true}
        tickValues={[0, 0.25, 0.5, 0.75, 1]}
        label="Proportion of Day"
        axisLabelComponent={<VictoryLabel angle={-90} />}
        tickFormat={(tick: number) => {
          switch (tick) {
            case 0:
              return "0.00"
            case 0.25:
              return "0.25"
            case 0.5:
              return "0.50"
            case 0.75:
              return "0.75"
            case 1:
              return "1.00"
            default:
              return ""
          }
        }}
        style={{
          tickLabels: chartTickLabelStyle,
          axisLabel: chartAxisLabelStyle,
          grid: { stroke: colors.neutral.clay },
          axis: { stroke: colors.neutral.clay },
        }}
      />

      {data.map((datum, index) => (
        <VictoryLine
          key={index}
          data={datum.map(({ x, y }) => ({ x, y }))}
          categories={{
            x: categories,
          }}
          style={{
            data: {
              stroke: datum[0]?.darkColor,
              strokeWidth: 2,
            },
          }}
        />
      ))}

      {data.map((datum, index) => (
        <VictoryScatter
          key={index}
          data={datum}
          symbol="circle"
          size={6}
          style={{
            data: {
              stroke: datum[0]?.darkColor,
              strokeWidth: 2,
              fill: datum[0]?.lightColor,
            },
          }}
          labelComponent={
            <VictoryTooltip
              flyoutComponent={
                <ChartTooltip
                  width={160}
                  crosshair={{
                    chartHeight: TREND_CHART.height,
                    paddingTop: TREND_CHART.padding.top,
                    paddingBottom: TREND_CHART.padding.bottom,
                  }}
                />
              }
            />
          }
        />
      ))}
    </VictoryChart>
  </div>
)

export default TimeAtHomeChart
